import { useAuthContext } from './useAuthContext'
import { useDevicesContext } from './useDevicesContext'
import { useSystemsContext  } from './useSystemsContext'

export const useLogout = () => {
  const { dispatch } = useAuthContext()
  const { dispatch: dispatchDevices } = useDevicesContext()
  const { dispatch: dispatchSystems } = useSystemsContext()

  const logout = () => {
    // remove user from storage
    localStorage.removeItem('user')

    // dispatch logout action
    dispatch({ type: 'LOGOUT' })
    dispatchDevices({ type: 'SET_DEVICES', payload: null })
    dispatchSystems({ type: 'SET_SYSTEM', payload: null })

  }

  return { logout }
}